var _path, _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3427 7.63392L8.2286 0.519863C7.94404 0.235301 7.54881 0.0614014 7.11406 0.0614014H1.5809C0.711406 0.0614014 0 0.772807 0 1.6423V7.17546C0 7.61021 0.173899 8.00544 0.466366 8.2979L7.58043 15.412C7.86499 15.6965 8.26022 15.8704 8.69496 15.8704C9.12971 15.8704 9.52494 15.6965 9.8095 15.4041L15.3427 9.8709C15.6351 9.58634 15.809 9.19111 15.809 8.75637C15.809 8.32162 15.6272 7.91849 15.3427 7.63392ZM2.76658 4.01366C2.1105 4.01366 1.5809 3.48406 1.5809 2.82798C1.5809 2.17191 2.1105 1.6423 2.76658 1.6423C3.42265 1.6423 3.95226 2.17191 3.95226 2.82798C3.95226 3.48406 3.42265 4.01366 2.76658 4.01366Z",
    fill: "#6E7389"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2075_2430)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.65958,
    y: 5.20728,
    width: 18.3306,
    height: 12.6472,
    rx: 3.79417,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.45,
    y: 5.99768,
    width: 16.7497,
    height: 11.0663,
    fill: "#6E7389"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8813 4.78442H8.39276C7.457 4.78442 6.71513 5.53453 6.71513 6.47006L6.7067 16.5839C6.7067 17.5194 7.457 18.2695 8.39276 18.2695H21.8813C22.8171 18.2695 23.5674 17.5194 23.5674 16.5839V6.47006C23.5674 5.53453 22.8171 4.78442 21.8813 4.78442ZM12.1864 14.0554H11.1748L9.02504 11.1056V14.0554H7.97125V8.99852H9.02504L11.1326 11.9484V8.99852H12.1864V14.0554ZM16.4016 10.0605H14.294V11.0044H16.4016V12.0664H14.294V13.0019H16.4016V14.0554H13.0295V8.99852H16.4016V10.0605ZM22.3028 13.2126C22.3028 13.6762 21.9235 14.0554 21.4598 14.0554H18.0877C17.624 14.0554 17.2446 13.6762 17.2446 13.2126V8.99852H18.2984V12.7996H19.251V9.83291H20.3048V12.7912H21.249V8.99852H22.3028V13.2126Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.0548,
    y: 5.6025,
    width: 17.5401,
    height: 11.8568,
    rx: 3.39894,
    stroke: "#6E7389",
    strokeWidth: 0.790451
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2075_2430"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.65958,
    y: 5.20728,
    width: 18.3306,
    height: 12.6472,
    rx: 3.79417,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.21e2d7ff7d1e24bfeb684d0cf90f639e.svg";
export { ForwardRef as ReactComponent };